import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AppConfig } from '@frontend/sports/common/client-config-data-access';
import { CookieProvider } from '@frontend/sports/common/core/utils/cookie-provider';
import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';
import { OnAppInit, UserLoginEvent, UserLogoutEvent } from '@frontend/vanilla/core';

import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class UserAccountIdCookieService implements OnAppInit {
    private appConfig = inject(AppConfig);
    private userService = inject(UserService);
    private cookieProvider = inject(CookieProvider);
    private destroyRef = inject(DestroyRef);
    private productUtils = inject(SportsProductUtils);

    readonly accountIdCookieName = 'currentAccountId';

    onAppInit(): void {
        if (!this.appConfig.setAccountIdCookie) {
            return;
        }

        this.setAccountIdCookie(this.userService.getPGAccountId());

        this.userService.events.pipe(this.productUtils.filterSportsEmitLast(), takeUntilDestroyed(this.destroyRef)).subscribe((action) => {
            if (action instanceof UserLoginEvent) {
                this.setAccountIdCookie(this.userService.getPGAccountId());
                return;
            }
            if (action instanceof UserLogoutEvent) {
                this.setAccountIdCookie(null);
            }
        });
    }

    private setAccountIdCookie(accountId: string | null) {
        if (accountId) {
            this.cookieProvider.setCookie(this.accountIdCookieName, accountId);
            return;
        }
        this.cookieProvider.deleteCookie(this.accountIdCookieName);
    }
}
